const colors = {
  blue: {
    50: '#F7FBFD',
    100: '#E8F6FC',
    200: '#D3F1FF',
    300: '#9EDBFA',
    400: '#67C5F4',
    500: '#3CB2ED',
    600: '#0C97DD',
    700: '#0984C2',
    800: '#056DA2',
    900: '#005A87',
  },

  gray: {
    50: '#F8F9FB',
    100: '#EDF1F4',
    200: '#E4EBEF',
    300: '#D8E2E8',
    400: '#CED9E0',
    500: '#C0CED5',
    600: '#ABBDC7',
    700: '#8EA5B1',
    800: '#69818E',
    900: '#50646E',
  },

  orange: {
    50: '#FEF5E8',
    100: '#FFE7C9',
    200: '#FFDBB0',
    300: '#FFC785',
    400: '#FEAE55',
    500: '#FF9739',
    600: '#FB7B37',
    700: '#EB6929',
    800: '#DF5925',
    900: '#CC5322',
  },

  white: '#FFFFFF',
  dark: 'var(--Primary-Text-Color, #111928)',
  text: 'rgba(71, 67, 65, 1)',
  stroke: 'rgba(156, 163, 175, 1)',
};

export default colors;
